"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "plant-nursery-table table-items-list contracts-table"
  }, [_c("b-table", {
    attrs: {
      data: _vm.tableData,
      loading: _vm.isLoading,
      striped: true,
      hoverable: true,
      "mobile-cards": true
    },
    on: {
      "update:loading": function updateLoading($event) {
        _vm.isLoading = $event;
      }
    }
  }, [_c("b-table-column", {
    attrs: {
      field: "contractNumber",
      label: "Contrato",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.contractNumber || "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "client.name",
      label: "Cliente",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$client;
        return [_vm._v("\n      " + _vm._s(((_props$row$client = props.row.client) === null || _props$row$client === void 0 ? void 0 : _props$row$client.name) || "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "signatureDate",
      label: "Assinatura",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatDate(props.row.signatureDate)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "deliveryDate",
      label: "Entrega",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatDate(props.row.deliveryDate)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "totalPlants",
      label: "Total de mudas"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$totalPlant;
        return [_vm._v("\n      " + _vm._s((_props$row$totalPlant = props.row.totalPlants) !== null && _props$row$totalPlant !== void 0 ? _props$row$totalPlant : 0) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "quantityDelivered",
      label: "Entregues"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        var _props$row$quantityDe;
        return [_vm._v("\n      " + _vm._s((_props$row$quantityDe = props.row.quantityDelivered) !== null && _props$row$quantityDe !== void 0 ? _props$row$quantityDe : 0) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "lotType",
      label: "Tipo de lote"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatLotType(props.row.lotType)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "progress",
      label: "Progresso"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("div", {
          attrs: {
            styles: "text-align: center;"
          }
        }, [_vm._v("\n        " + _vm._s((props.row.progress || 0).toFixed(0)) + "%\n      ")]), _vm._v(" "), _c("b-progress", {
          attrs: {
            value: props.row.progress || 0,
            size: "is-small",
            type: "is-primary"
          }
        }, [_c("span", [_vm._v(_vm._s((props.row.progress || 0).toFixed(0)) + "%")])])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      label: "Ações",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("b-dropdown", {
          attrs: {
            position: "is-bottom-left"
          }
        }, [_c("b-button", {
          staticClass: "is-text",
          attrs: {
            slot: "trigger",
            "icon-right": "dots-vertical"
          },
          slot: "trigger"
        }), _vm._v(" "), _c("b-dropdown-item", {
          on: {
            click: function click($event) {
              return _vm.$emit("edit", props.row);
            }
          }
        }, [_vm._v("\n          Editar\n        ")]), _vm._v(" "), _c("b-dropdown-item", {
          on: {
            click: function click($event) {
              return _vm.$emit("delete", props.row);
            }
          }
        }, [_vm._v("\n          Remover\n        ")])], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;